export const EDITORIAL_TEMPLATE = 0;
export const PLAYLIST_HORIZONTAL_TEMPLATE = 1;
export const PLAYLIST_VERTICAL_TEMPLATE = 2;
